<div class="container-fluid">
  <h1>
    {{ 'events.event-type.event-type-edit-component.event-type-label' | translate | titlecase }}
  </h1>

  <p>
    <button app-add-button
      [label]="'events.event-type.event-type-edit-component.add-button-label' | translate | titlecase"
      (onClick)="newEventType()"
    >
    </button>
  </p>

  <p [hidden]="!loadingEventTypes">
    <wl-busy [show]="loadingEventTypes"></wl-busy>
    {{ 'common.loading' | translate | titlecase }}...
  </p>

  <p [hidden]="loadingEventTypes || eventTypes?.length">
    {{ 'events.event-type.event-type-edit-component.no-event-types' | translate | titlecase }}
  </p>

  <p-table [showGridlines]="true"
    #eventTypeDataGrid
    class="col-md-6"
    [lazy]="true"
    [rows]="10"
    [value]="eventTypes"
    [paginator]="true"
    (onLazyLoad)="lazyLoadEventTypes($event)"
    [totalRecords]="searchResult.TotalCount"
    [hidden]="loadingEventTypes || !eventTypes?.length"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="EventType">
          {{ 'events.event-type.event-type-edit-component.event-type-label' | translate | titlecase }}
          <p-sortIcon field="EventType"></p-sortIcon>
        </th>
        <th>{{ 'events.event-type.event-type-edit-component.descr-label' | translate | titlecase }}</th>
        <th style="width: 80px">
          {{ 'events.event-type.event-type-edit-component.is-public-label' | translate | titlecase }}
        </th>
        <th style="width: 200px"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-type>
      <tr>
        <td>{{ type.EventType }}</td>
        <td>{{ type.Descr }}</td>
        <td><input type="checkbox" [ngModel]="type.IsPublic" disabled /></td>
        <td>
          <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="editEventType(type.EventType)" icon="pi pi-pencil"></button>

          <button
            pButton
            type="button"
            class="btn btn-danger"
            (click)="type._canDelete = false; confirmDeleteEventType(type.EventType)"
            [disabled]="!type._canDelete"
            icon="pi pi-trash"
          ></button>

          <input type="checkbox" [(ngModel)]="type._canDelete" class="ml-2" />
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
</div>

<p-dialog
  #eventTypeModal
  [modal]="true"
  [(visible)]="showEventTypeModal"
  [closable]="false"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ 'events.event-type.event-type-edit-component.event-type-label' | translate | titlecase }}</h4>
  </ng-template>

  <form novalidate #eventTypeForm="ngForm">
    <p *ngIf="loadingEventType.busy">
      <wl-busy [show]="loadingEventType.busy"></wl-busy>
    </p>

    <div class="alert alert-danger" *ngIf="loadingEventType.message && !loadingEventType.success">
      {{ loadingEventType.message }}
    </div>

    <div class="alert alert-danger" *ngIf="eventTypeField.invalid && eventTypeField.touched">
      {{ 'events.event-type.event-type-edit-component.no-event-type-error' | translate }}
    </div>

    <div class="container-fluid" [hidden]="loadingEventType.busy">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ 'events.event-type.event-type-edit-component.event-type-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input
              pattern="^\w(?:.*?\w$)?"
              [disabled]="editing"
              name="event-type"
              #eventTypeField="ngModel"
              class="form-control"
              type="text"
              [(ngModel)]="selectedEventType.EventType"
              required
            />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ 'events.event-type.event-type-edit-component.descr-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input class="form-control" name="descr" type="text" [(ngModel)]="selectedEventType.Descr" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ 'events.event-type.event-type-edit-component.is-public-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input type="checkbox" name="is-public" [(ngModel)]="selectedEventType.IsPublic" />
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!savingError">{{ savingError }}</div>
    <wl-busy [show]="saving"></wl-busy>

    <button
      pButton
      type="button"
      class="btn btn-primary"
      [disabled]="eventTypeForm.invalid || saving"
      (click)="editing = false; saveEventTypes()"
      icon="pi pi-save"
      [label]="(saving ? 'common.saving' : 'common.save') | translate | titlecase"
    ></button>

    <button
      pButton
      type="button"
      class="btn btn-secondary"
      (click)="editing = false; this.showEventTypeModal = false"
      [disabled]="saving"
      icon="pi pi-ban"
      [label]="'common.cancel' | translate | titlecase"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  #confirmDeleteEventTypeModal
  [modal]="true"
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <div [hidden]="!findingEvents">
    <wl-busy [show]="findingEvents"></wl-busy>
  </div>

  <div [hidden]="findingEvents || !anyEvents">
    {{ 'events.event-type.event-type-edit-component.delete-migrate-confirm' | translate }}<br />
    <select class="form-control" [(ngModel)]="eventTypeToMigrateTo">
      <option value="null">None</option>
      <option *ngFor="let type of getAllButOneEventType()" [value]="type.EventType">
        {{ type.EventType }}
      </option>
    </select>
  </div>

  <div [hidden]="findingEvents || anyEvents">
    {{ 'events.event-type.event-type-edit-component.delete-confirm' | translate }}
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!deleteError">{{ deleteError }}</div>
    <wl-busy [show]="deleting"></wl-busy>

    <ng-container *ngIf="!anyEvents; else migrateTemplate">
      <button
        pButton
        type="button"
        class="btn btn-danger"
        (click)="deleteEventType()"
        [disabled]="deleting"
        icon="pi pi-trash"
        [label]="(deleting ? 'common.deleting' : 'common.delete') | translate | titlecase"
      ></button>
    </ng-container>

    <ng-template #migrateTemplate>
      <button
        pButton
        type="button"
        class="btn btn-danger"
        (click)="deleteMigrateEventType()"
        [disabled]="deleting"
        icon="pi pi-trash"
        [label]="
          (deleting
            ? 'events.event-type.event-type-edit-component.delete-migrating'
            : 'events.event-type.event-type-edit-component.delete-migrate'
          )
            | translate
            | titlecase
        "
      ></button>
    </ng-template>

    <button
      pButton
      type="button"
      class="btn btn-secondary"
      (click)="this.showDeleteModal = false"
      [disabled]="deleting"
      icon="pi pi-ban"
      [label]="'common.cancel' | translate | titlecase"
    ></button>
  </ng-template>
</p-dialog>
